import { Link as RouterLink } from 'react-router-dom';
import { UserButton, useAuth } from '@clerk/clerk-react';
import {
  Box,
  Flex,
  HStack,
  Button,
  Text,
  Link,
  Container,
} from '@chakra-ui/react';

function Navbar() {
  const { isSignedIn } = useAuth();

  return (
    <Box bg="white" borderBottom="1px" borderColor="gray.200">
      <Container maxW="container.xl">
        <Flex h={16} alignItems="center" justifyContent="space-between">
          <HStack gap={8} alignItems="center">
            <Link asChild>
              <RouterLink to="/">
                <Text fontSize="xl" fontWeight="bold" color="brand.500">
                  Jezweb Quotes
                </Text>
              </RouterLink>
            </Link>

            {isSignedIn && (
              <HStack gap={4}>
                <Link asChild>
                  <RouterLink to="/dashboard">Dashboard</RouterLink>
                </Link>
                <Link asChild>
                  <RouterLink to="/quote/new">New Quote</RouterLink>
                </Link>
              </HStack>
            )}
          </HStack>

          <HStack gap={4}>
            {isSignedIn ? (
              <UserButton afterSignOutUrl="/" />
            ) : (
              <>
                <Button asChild variant="ghost">
                  <RouterLink to="/sign-in">Sign In</RouterLink>
                </Button>
                <Button asChild colorPalette="brand">
                  <RouterLink to="/sign-up">Get Started</RouterLink>
                </Button>
              </>
            )}
          </HStack>
        </Flex>
      </Container>
    </Box>
  );
}

export default Navbar;